import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20background%20with%20flowing%20gradients%20in%20soft%20coral%20and%20cream%20tones%2C%20minimalist%20design%2C%20gentle%20curves%2C%20airy%20atmosphere%2C%20subtle%20light%20effects%2C%20suitable%20for%20a%20call%20to%20action%20section%2C%20no%20text&width=1600&height=800&seq=cta-bg-manga&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary-500/90"></div>
      </div>

      <div className="relative z-10 max-w-screen-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好开启你的漫画之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto mb-8">
          数千部精选韩漫等你发现，完全免费，随时随地享受阅读的乐趣
        </p>
        <Link
          to="/category/all"
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50 text-primary-600 font-medium text-sm hover:bg-background-100 transition-all whitespace-nowrap"
        >
          立即探索 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}